export default __webpack_public_path__ + "static/media/Settlement.b3bb705f.svg";